import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.formcontrols.who.can.see': {
    id: 'profile.formcontrols.who.can.see',
    defaultMessage: 'Who can see this:',
    description: 'What users can see this area?',
  },
  'profile.formcontrols.button.cancel': {
    id: 'profile.formcontrols.button.cancel',
    defaultMessage: 'Cancel',
    description: 'A button label',
  },
  'profile.formcontrols.button.save': {
    id: 'profile.formcontrols.button.save',
    defaultMessage: 'Save',
    description: 'A button label',
  },
  'profile.formcontrols.button.saving': {
    id: 'profile.formcontrols.button.saving',
    defaultMessage: 'Saving',
    description: 'A button label',
  },
  'profile.formcontrols.button.saved': {
    id: 'profile.formcontrols.button.saved',
    defaultMessage: 'Saved',
    description: 'A button label',
  },
});

export default messages;
